module.exports = __webpack_public_path__ + "img/20230901075809322sih.50b159a9.jpg";